import axios from 'axios'
import { BUSCAR_MANUTENCOES_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarRegistrosManutencaoVeiculo (veiculoId, empresaId, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/registro-manutencao-veiculo/veiculo/${veiculoId}/empresa/${empresaId}${urlFiltros}`;
    
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_MANUTENCOES_VEICULO,
      payload: {
        manutencoesVeiculo: response.data,        
      }
    })
  )
}
